export const RED = "#E50914";
export const GRAY = "#b6b6b6";
export const DEFAULT_COLOR = "#7E7E7E";
export const DEFAULT_QUIZ_TEXT_COLOR = "#151515";
export const DEFAULT_QUIZ_BACKGROUND_COLOR = "#FFFFFF";
